import type { AppStatus_Realworks_FullSync__KenmerkMapping__Input } from '~/graphql/types';
import type { KenmerkLookup } from '../../types';
import flattenKenmerkLookup from '../flattenKenmerkLookup';

const transformFrontendKenmerken_FullSync = (
  kenmerkLookup: KenmerkLookup | null,
): Array<AppStatus_Realworks_FullSync__KenmerkMapping__Input> =>
  flattenKenmerkLookup(kenmerkLookup).map(({ id, tag }) => ({
    realworksKenmerkId: id,
    tag,
  }));

export default transformFrontendKenmerken_FullSync;
